import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import {
  BreadCrumb,
  ApiLoadingSpinner,
  ApiUpdatingSpinner,
  ApiRequestError,
  Button,
  Header,
} from "@funcional/react-ui";
import { Restricted } from "@funcional/react-auth-ui";
import { UserCard } from "@sso/users/components";
import { useUser } from "@sso/users/hooks";

export default function ViewUserPage() {
  let { uuid }: { uuid: string } = useParams();
  const { status, data, error, isFetching } = useUser(uuid);
  const history = useHistory();

  return (
    <>
      <Header
        title="Ver Usuário"
        backTo="/sso/users"
        buttons={
          <Restricted to="edit.users">
            <Button
              color="primary"
              onClick={() => history.push(`/sso/users/${uuid}/edit`)}
            >
              Editar Usuário
            </Button>
          </Restricted>
        }
      >
        <BreadCrumb
          marginBottom={0}
          items={[
            { path: "/sso/users", label: "Usuários" },
            { label: `#${uuid}` },
          ]}
        />
      </Header>

      {status === "loading" ? (
        <ApiLoadingSpinner />
      ) : status === "error" ? (
        <ApiRequestError error={error} />
      ) : (
        <>
          {data ? <UserCard user={data} /> : <p>Usuário não encontrado.</p>}
          {isFetching ? <ApiUpdatingSpinner /> : null}
        </>
      )}
    </>
  );
}
